import type { FC, PropsWithChildren, ReactNode } from 'react';

import Icon from 'app/components/Icon';
import waitIcon from 'app/icons/wait.svg';
import doneIcon from 'app/icons/done.svg';

import style from './style.scss';

interface Props extends PropsWithChildren {
  icon: 'done' | 'wait';
  sectionTitle?: string;
  title: string;
  subtitle?: string;
  action?: ReactNode;
}

const LoginContent: FC<Props> = ({ icon, subtitle, title, action, children, sectionTitle }) => (
  <div className={style.loginContent}>
    {sectionTitle && <h4>{sectionTitle}</h4>}
    <div className={style.loginContentHeader}>
      <Icon href={icon === 'done' ? doneIcon : waitIcon} className={style.loginContentIcon} />
      <div className={style.loginContentTitle}>{title}</div>
      {subtitle && <div className={style.loginContentSubtitle}>{subtitle}</div>}
    </div>
    {children}
    {action && <div className={style.loginContentAction}>{action}</div>}
  </div>
);

LoginContent.displayName = 'LoginContent';

export default LoginContent;
